/**
 * ? @description : Dashboard Component
 */

// Dependencies
import React, { Fragment, useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Axios from "../../../axios/Axios";

//assets
import totalTeachersImg from "../../../assets/total-teachers.svg";
import totalStudentsImg from "../../../assets/total-students.svg";
import totalBatchesImg from "../../../assets/total-batches.svg";
import mappedProfilesImg from "../../../assets/mapped-profiles.svg";
import unmappedTeachersImg from "../../../assets/unmapped-teachers-count.svg";
import unmappedStudentsImg from "../../../assets/unmapped-students-count.svg";


// CSS
import "../../../css/Dashboard.css";

//Redux
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../redux/features/appSlice";

// Components
import StudentPerformances from "./performances/StudentPerformances";
import AudioApprovedTeachers from "./performances/AudioApprovedTeachers";
import StudentsLevelCount from "./levels_count/StudentsLevelCount";
import AudioPending from "./levels_count/AudioPending";
import { Card } from "@mui/material";
import axios from "axios";




export default function Dashboard() {
  // * Router Variable
  const navigate = useNavigate();
  const dispatch = useDispatch();
  //State to total count tabs
  const [teacherCount, setTeacherCount] = useState(0);
  const [studentCount, setStudentCount] = useState(0);
  const [mappedCount, setMappedCount] = useState(0);
  const [groupCount, setGroupCount] = useState(0);
  const [unmappedTeachersCount, setUnmappedTeachersCount] = useState(0);
  const [unmappedStudentsCount, setUnmappedStudentsCount] = useState(0);
  

  
  
  //GET Request for Teacher count, student count, mapped count, group count
  // const getCountObject = [
  //   {
  //     getUrl: "teachercount",
  //     countName: "Total Teachers",
  //     imgSource : archive,
  //     navUrl : "/category/teachers"
  //   },
  //   {
  //     getUrl: "studentcount",
  //     countName : "Total Students",
  //     imgSource : compass,
  //     navUrl : "/category/students"
  //   }, 
  //   {
  //     getUrl: "mappedcount",
  //     countName : "Total Batches",
  //     imgSource : archive,
  //     navUrl : "/lte-session/batch"
  //   }, 
  //   {
  //     getUrl: "groupcount",
  //     countName : "Mapped Profiles",
  //     imgSource : compass,
  //     navUrl : "/category/mapped"
  //   }
  // ];

  // useEffect(() => {  
  //   getCountObject.map((countObj) => {
  //     (async () => {
  //       try{
  //         const options = {
  //           method: "get",
  //           url: `/dashboard/${countObj.getUrl}`,
  //           auth: true,
  //           data: null,
  //         };
    
  //         const response = await Axios(
  //           options.method,
  //           options.url,
  //           options.auth,
  //           options.data
  //         );
          
  //         if(response.status === 200 && response.statusText === "OK"){
  //           let [obj] = response.data;
  //           let totalCount = Object.values(obj)[0];
  //           // console.log(totalCount);
            
  //           setStatState(prevState => {
  //             return [...prevState, { ...countObj, totalCount }]
  //           })
  //         }
  //       }catch(error){
  //         dispatch(
  //           showSnackbar({
  //             message: "Couldn't able to retrieve counts",
  //             severity: "error",
  //           })
  //         );
  //       }
  //     })();
  //   })
  // }, [])

  async function getCountData(getUrl, countName, setState){
    const controller = axios.CancelToken.source();
    try{
      const options = {
        method: "get",
        url: `dashboard/${getUrl}`,
        auth: true,
        data: null,
        token:{cancelToken: controller.token}
      };

      const response = await Axios(
        options.method,
        options.url,
        options.auth,
        options.data,
        options.token,
        );
      if(response.status === 200){
        let [obj] = response.data;
        let totalCount = Object.values(obj)[0];
        
        setState(totalCount);
      }
    }catch(error){
      if(!axios.isCancel(error)){      
        dispatch(
        showSnackbar({
          message: `Couldn't able to retrieve ${countName} Count`,
          severity: "error",
        })
      )}
    } finally{
      // controller.cancel();
  }
  }
  
  useEffect(() => {
    
    getCountData("teachercount", "Total teachers", setTeacherCount);
    getCountData("studentcount", "Total students", setStudentCount);
    getCountData("groupcount", "Total Batches", setGroupCount);
    getCountData("mappedcount", "Mapped Profiles", setMappedCount);
    getCountData("unmapped/teacherscount", "Unmapped Teachers", setUnmappedTeachersCount);
    getCountData("unmapped/studentscount", "Unmapped Students", setUnmappedStudentsCount);
    return () => { }
  },[])
  
  return (
    <div style={{
      display: "flex",
      flexDirection: "column"
    }}>
      {/* Photo Cards */}
      <div style={{display: "flex",gap: 35, justifyContent: "space-between"}} className="px-5 py-3 dashboard">
        <div style={{
          display: "flex",
          flexDirection: "column",
          gap: "35px",
          width: "100%",
          justifyContent: "space-evenly",
          flex: 3
        }}>
            <div style={{
              display: "flex",
              flexDirection: "row",
              gap: "35px",
              justifyContent: "space-between",
            }}>
              {/* Total Teachers Count */}
              <div className="tile"
                onClick={() => navigate("/category/teachers")}
              >
                <div>
                  <img  className="card__img" src={totalTeachersImg} alt="img" />
                </div>            
                <div>
                  <h1 className="card__title">{teacherCount}</h1>
                  <h4 className="card__content">Total Teachers</h4>
                </div>
                <div className="card__arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="15" width="15">
                        <path fill="#fff" d="M13.4697 17.9697C13.1768 18.2626 13.1768 18.7374 13.4697 19.0303C13.7626 19.3232 14.2374 19.3232 14.5303 19.0303L20.3232 13.2374C21.0066 12.554 21.0066 11.446 20.3232 10.7626L14.5303 4.96967C14.2374 4.67678 13.7626 4.67678 13.4697 4.96967C13.1768 5.26256 13.1768 5.73744 13.4697 6.03033L18.6893 11.25H4C3.58579 11.25 3.25 11.5858 3.25 12C3.25 12.4142 3.58579 12.75 4 12.75H18.6893L13.4697 17.9697Z"></path>
                    </svg>
                </div>
              </div>

              <div className="tile"
                onClick={() => navigate("/category/students")}
              >
                <div>
                  <img className="card__img" src={totalStudentsImg} alt="img" />
                </div>  
                <div>
                <h1 className="card__title">{studentCount}</h1>
                <h4 className="card__content">Total Students</h4>
                </div>
                <div className="card__arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="15" width="15">
                        <path fill="#fff" d="M13.4697 17.9697C13.1768 18.2626 13.1768 18.7374 13.4697 19.0303C13.7626 19.3232 14.2374 19.3232 14.5303 19.0303L20.3232 13.2374C21.0066 12.554 21.0066 11.446 20.3232 10.7626L14.5303 4.96967C14.2374 4.67678 13.7626 4.67678 13.4697 4.96967C13.1768 5.26256 13.1768 5.73744 13.4697 6.03033L18.6893 11.25H4C3.58579 11.25 3.25 11.5858 3.25 12C3.25 12.4142 3.58579 12.75 4 12.75H18.6893L13.4697 17.9697Z"></path>
                    </svg>
                </div>
              </div>

              <div className="tile"
                onClick={() => navigate("/lte-session")}
              >
                <div>
                  <img className="card__img" src={totalBatchesImg} alt="img" />
                </div>
                <div>
                  <h1 className="card__title">{groupCount}</h1>
                  <h4 className="card__content">Total Batches</h4>
                </div>
                <div className="card__arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="15" width="15">
                        <path fill="#fff" d="M13.4697 17.9697C13.1768 18.2626 13.1768 18.7374 13.4697 19.0303C13.7626 19.3232 14.2374 19.3232 14.5303 19.0303L20.3232 13.2374C21.0066 12.554 21.0066 11.446 20.3232 10.7626L14.5303 4.96967C14.2374 4.67678 13.7626 4.67678 13.4697 4.96967C13.1768 5.26256 13.1768 5.73744 13.4697 6.03033L18.6893 11.25H4C3.58579 11.25 3.25 11.5858 3.25 12C3.25 12.4142 3.58579 12.75 4 12.75H18.6893L13.4697 17.9697Z"></path>
                    </svg>
                </div>
              </div>

            </div>
            <div style={{
              display: "flex",
              flexDirection: "row",
              gap: "35px",
              justifyContent: "space-between",
            }}>
              <div className="tile"
                  onClick={() => navigate("/category/mapped")}
                >
                  <div>
                    <img className="card__img" src={mappedProfilesImg} alt="img" />
                  </div>
                  <div>
                    <h1 className="card__title">{mappedCount}</h1>
                    <h4 className="card__content">Mapped Profiles</h4>
                  </div>
                
                  <div className="card__arrow">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="15" width="15">
                          <path fill="#fff" d="M13.4697 17.9697C13.1768 18.2626 13.1768 18.7374 13.4697 19.0303C13.7626 19.3232 14.2374 19.3232 14.5303 19.0303L20.3232 13.2374C21.0066 12.554 21.0066 11.446 20.3232 10.7626L14.5303 4.96967C14.2374 4.67678 13.7626 4.67678 13.4697 4.96967C13.1768 5.26256 13.1768 5.73744 13.4697 6.03033L18.6893 11.25H4C3.58579 11.25 3.25 11.5858 3.25 12C3.25 12.4142 3.58579 12.75 4 12.75H18.6893L13.4697 17.9697Z"></path>
                      </svg>
                  </div>
                </div>

                <div className="tile"
                  onClick={() => navigate("/category/unmapped")}
                >
                  <div>
                    <img className="card__img" src={unmappedTeachersImg} alt="img" />
                  </div>
                  <div>
                    <h1 className="card__title">{unmappedTeachersCount}</h1>
                    <h4 className="card__content">Unmapped Teachers</h4>
                  </div>
                  
                  <div className="card__arrow">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="15" width="15">
                          <path fill="#fff" d="M13.4697 17.9697C13.1768 18.2626 13.1768 18.7374 13.4697 19.0303C13.7626 19.3232 14.2374 19.3232 14.5303 19.0303L20.3232 13.2374C21.0066 12.554 21.0066 11.446 20.3232 10.7626L14.5303 4.96967C14.2374 4.67678 13.7626 4.67678 13.4697 4.96967C13.1768 5.26256 13.1768 5.73744 13.4697 6.03033L18.6893 11.25H4C3.58579 11.25 3.25 11.5858 3.25 12C3.25 12.4142 3.58579 12.75 4 12.75H18.6893L13.4697 17.9697Z"></path>
                      </svg>
                  </div>
                </div>

                <div className="tile"
                  onClick={() => navigate("/category/unmapped")}
                >
                  <div>
                    <img className="card__img" src={unmappedStudentsImg} alt="img" />
                  </div>
                  <div>
                    <h1 className="card__title">{unmappedStudentsCount}</h1>
                    <h4 className="card__content">Unmapped Students</h4>
                  </div>
                  
                  <div className="card__arrow">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="15" width="15">
                          <path fill="#fff" d="M13.4697 17.9697C13.1768 18.2626 13.1768 18.7374 13.4697 19.0303C13.7626 19.3232 14.2374 19.3232 14.5303 19.0303L20.3232 13.2374C21.0066 12.554 21.0066 11.446 20.3232 10.7626L14.5303 4.96967C14.2374 4.67678 13.7626 4.67678 13.4697 4.96967C13.1768 5.26256 13.1768 5.73744 13.4697 6.03033L18.6893 11.25H4C3.58579 11.25 3.25 11.5858 3.25 12C3.25 12.4142 3.58579 12.75 4 12.75H18.6893L13.4697 17.9697Z"></path>
                      </svg>
                  </div>
                </div>
            </div>
          </div>

        {/* Audio Approved Teachers List */}
        <Card
          elevation={0}
          sx={{ 
            padding: "10px", 
            height: "400px", 
            overflowY: "scroll", 
            flex: 1, 
            borderRadius: "0.7rem",
            '&::-webkit-scrollbar': {
              width: '3px',
            },
            '&::-webkit-scrollbar-track': {
              boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
              webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#1D3FAA',
              // outline: '3px solid #FAFAFA',
          } 
          }}
        >
          <AudioApprovedTeachers />
        </Card>
      </div>

      {/* Students Performances & Audio Approved Teachers */}
      <div style={{ 
          display: "flex",
          flexDirection: "row",
          gap: 25
        }} 
        className="px-5 py-3 dashboard"
      >

        {/* Students Levels Count */}
        <Card elevation={0} style={{ padding: "10px", height: "400px", flex: 3, borderRadius: "0.7rem" }}>
          <StudentsLevelCount />
        </Card>

        {/* Audio Pending Volunteers */}
        <Card
          elevation={0}
          sx={{ 
            padding: "10px", 
            height: "400px", 
            overflowY: "scroll", 
            flex: 1, 
            borderRadius: "0.7rem",
            '&::-webkit-scrollbar': {
              width: '3px',
            },
            '&::-webkit-scrollbar-track': {
              boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
              webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#1D3FAA',
              // outline: '3px solid #FAFAFA',
          } 
          }}
        >
          <AudioPending />
        </Card>
      </div>
    </div>
  );
}
